

















import { Component, Vue } from 'vue-property-decorator';
import JobSafetyDocs from '@/components/jobSafetyDocs/JobSafetyDocs.vue';
import { JobSafetyDoc } from '@/models/jobSafetyDocs/jobSafetyDoc';
import * as JobsAPI from '@/api/jobsApi';
import Nullable from '@/types/nullable';

@Component({
  components: {
    JobSafetyDocs
  }
})
export default class ViewJobServiceForm extends Vue {
  private loading: boolean = false;
  private errorMessage: string = null;
  private jobSafetyDocs: Nullable<JobSafetyDoc[]> = null;
  
  created() {
    this.init();
  }

  handleDataChanged(){
    this.init();
  }

  async init(){
    this.loading = true;

    try {
      this.jobSafetyDocs = await JobsAPI.getSafetyDocs(this.$route.params.jobID);
    } catch (err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

